<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Alquiler de Bienes</v-toolbar-title>

                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="4">
                                <v-text-field color="green darken-2" dense v-model="fecha" label="Fecha"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <h6>Remito: {{ remito }}</h6>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="6">
                                <v-select item-color="green" color="green darken-2" dense v-model="origen"
                                    :items="listadodeposito" label="Depósito Origen" item-text="detalle"
                                    item-value="codigo"></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-select item-color="green" color="green darken-2" dense v-model="destino"
                                    :items="listadodeposito" label="Depósito Destino" item-text="detalle"
                                    item-value="codigo"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-data-table dense :headers="headers" :items="bienesalquiler" locale="es-ar" class="elevation-1"
                        :items-per-page="100" hide-default-footer>
                        <template v-slot:top>
                            <v-toolbar flat>

                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="headline">Está seguro que desea borrar?</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small color="red" @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.detalle="{ item }">
                            <div class="right-input">
                                <v-text-field color="green darken-2" dense v-model="item.detalle"></v-text-field>
                            </div>
                        </template>

                        <template v-slot:item.cantidad="{ item }">
                            <div class="right-input">
                                <v-text-field dense v-model="item.cantidad" single-line></v-text-field>
                            </div>
                        </template>

                    </v-data-table>
                    <v-btn dense class="mx-2" dark small color="orange" @click="addRow()">Agregar fila</v-btn>
                </v-card>
                <v-card>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea color="green darken-2" auto-grow rows="2" label="Observaciones" dense
                                    v-model="observ"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="8" md="8">
                                <v-text-field color="green darken-2" dense v-model="transporte"
                                    label="Transporte"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-text-field color="green darken-2" dense v-model="valor"
                                    label="Valor declarado"></v-text-field>
                            </v-col>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field color="green darken-2" dense v-model="preparo"
                                        label="Preparó"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field color="green darken-2" dense v-model="solicito"
                                        label="Solicitó"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field color="green darken-2" dense v-model="lugar"
                                        label="Lugar de entrega"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card color="green lighten-4" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>

                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data: (vm) => ({
        fecha: moment().format("DD/MM/YYYY"),
        equipo: "",
        remito: "",
        listadoequipo: [],
        codgral: "",
        origen: "SER",
        destino: "",
        dialogDelete: false,
        editedIndex: -1,
        editedItem: {
            item: "",
            codgral: "",
            cantidad: ""
        },
        defaultItem: {
            item: "",
            codgral: "",
            cantidad: ""
        },
        listadodeposito: [],
        count: "6",
        bienesalquiler: [
            { item: "1", detalle: "", cantidad: "1" },
            { item: "2", detalle: "", cantidad: "1" },
            { item: "3", detalle: "", cantidad: "1" },
            { item: "4", detalle: "", cantidad: "1" },
            { item: "5", detalle: "", cantidad: "1" },
            { item: "6", detalle: "", cantidad: "1" },
        ],
        alquiler: [],
        headers: [
            { text: "Bien", value: "detalle", width: "70%", sortable: false },
            { text: "Cantidad", value: "cantidad", width: "20%", sortable: false },
            { text: "Borrar", value: "actions", width: "10%", sortable: false },
        ],
        codigo: "",
        preparo: "",
        solicito: "",
        observ: "",
        transporte: "",
        lugar: "",
        valor: "",
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
    }),

    computed: {

        show: {
            get() {

                this.cargarRemito();
                this.cargarDepositos();
                //this.cargarEquipo();

            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        deleteItem(item) {
            this.editedIndex = this.bienesalquiler.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        deleteItemConfirm() {
            this.bienesalquiler.splice(this.editedIndex, 1);
            this.closeDelete();
        },

        cargarRemito() {
            let self = this;
            axios
                .get("/SSGG/CodigoRemito?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.remito = response.data;
                    self.preparo = this.$store.state.nombre.toString().trim();
                })
                .catch((error) => {
                    self.remito = "";
                    console.log(error);
                });
        },

        cargarDepositos() {
            let self = this;
            axios
                .get("/SSGG/CargarDepositos?", {
                    params: {
                        filtrocodigo: "",
                        filtrodetalle: "",
                        filtroestado: "",
                    },
                })
                .then((response) => {
                    self.listadodeposito = response.data;
                })
                .catch((error) => {
                    self.listadodeposito = "";
                    console.log(error);
                });
        },

        addRow(flag) {
            this.count = parseInt(this.count) + 1
            this.bienesalquiler.push({ item: this.count, detalle: "", cantidad: "1" },)
        },

        vaciarModels() {
            this.remito = "";
            this.fecha = "";
            this.origen = "";
            this.destino = "";
            this.solicito = "";
            this.realizo = "";
            this.observ = "";
            this.alquiler = [];
            this.transporte = "";
            this.valor = "";
            this.lugar = "";
            this.$router.push({ name: "MainSSGG" });
        },

        guardar() {
            this.$swal({
                title: "Guardar Alquiler",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                var i;
                if (result.value) {
                    this.deshabilitar = true;
                    this.bienesalquiler.forEach((element) => {
                        // console.log(element.codgral.codgral)
                        if (element.detalle != "" && element.detalle != null) {
                            this.alquiler.push({
                                item: element.item,
                                detalle: element.detalle,
                                cantidad: element.cantidad,

                            })

                            //  console.log("items" + this.alquiler)
                        }
                    })
                    var datos = {
                        remito: this.remito,
                        fecha: this.fecha,
                        origen: this.origen,
                        destino: this.destino,
                        transporte: this.transporte,
                        valor: this.valor,
                        preparo: this.preparo,
                        solicito: this.solicito,
                        observ: this.observ,
                        lugar: this.lugar,
                        alquiler: this.alquiler,
                    };

                    let self = this;
                    //  console.log("DATOS " + this.bienesalquiler[0].codgral)
                    axios
                        .post("/SSGG/GuardarAlquiler", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.imprimirAlquiler();
                            self.vaciarModels();
                            self.showAlert({
                                icon: "success",
                                title: "Alquiler guardado con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});

                } else {
                }
            });
        },



        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },


        imprimirAlquiler() {

            var vm = this;
            var columns = [
                { title: "Item", dataKey: "item" },
                { title: "Bien", dataKey: "detalle" },
                { title: "Cantidad", dataKey: "cantidad" },
            ];

            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);
            doc.line(10, 11, 10, 41);
            doc.line(40, 26, 200, 26);
            doc.addImage(
                "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",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(12);
            doc.text("ALQUILER DE BIENES", 60, 20);
            doc.setFontSize(10);
            doc.text("Fecha: " + vm.fecha, 155, 20);
            doc.text("Nota Envío: " + vm.remito, 155, 35);
            doc.line(40, 11, 40, 41);
            doc.line(150, 11, 150, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);

            doc.setFontSize(11);

            var final = 50; // Posición vertical inicial
            var i = 0;
            doc.setFontSize(12); // Tamaño de fuente del título
            doc.text("Depósito de Origen: " + vm.origen, 15, 50);
            doc.text("Depósito de Destino: " + vm.destino, 15, 55);
            var final = 60;

            doc.autoTable(columns, vm.alquiler, {
                startY: final,
                theme: 'grid',
                margin: { top: 10 },
            });
            // Actualiza la posición final para la próxima iteración
            final = doc.lastAutoTable.finalY + 10; // Añade 10 para espacio entre tablas

            // Verifica si es necesario agregar una nueva página
            if (final >= 250) {
                doc.addPage();
                final = 10; // Resetea la posición vertical
            }

            doc.text("Preparó: " + vm.preparo, 15, final + 10);
            doc.text("Solicitó: " + vm.solicito, 15, final + 20);
            doc.text("Transporte: " + vm.transporte, 15, final + 30);
            doc.text("Valor Declarado: " + vm.valor, 15, final + 35);
            doc.text("Lugar de entrega: " + vm.lugar, 15, final + 40);
            doc.text("Observaciones: " + vm.observ, 15, final + 45);



            doc.output('dataurlnewwindow');

            // doc.save("Alquileres" + vm.mes + vm.anio + ".pdf");

        },

    },
};
</script>
